import { useCallback, useEffect, useMemo } from 'react';

export default function useFileReader(onLoad: (data: string) => void) {
  const fileReader = useMemo(() => new FileReader(), []);
  const load = useCallback((file: File) => fileReader.readAsDataURL(file), []);

  useEffect(
    () => {
      const listener = () => {
        if (fileReader.result) {
          onLoad(fileReader.result as string);
        }
      };

      fileReader.addEventListener('load', listener);

      return () => {
        fileReader.removeEventListener('load', listener);
      };
    },
    [onLoad]
  );

  return load;
}
